
/**
 * @returns {import('vuex').Store}
 */
export const state = () => ({
	pedigree: {},
	specimenUpdate: {}
});
